<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input
                v-model="groupBuySettingManageInfo.conditions.groupBuyName"
                placeholder="请输入拼团名称"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="groupBuySettingManageInfo.conditions.validHours"
                placeholder="请输入拼团时效"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="groupBuySettingManageInfo.conditions.settingId"
                placeholder="请输入设置ID"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="_queryGroupBuySettingMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetGroupBuySettingMethod">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>设置信息</span>
            <el-button
              type="primary"
              size="small"
              style="float: right;"
              @click="_openAddGroupBuySettingModal"
            >
              <i class="el-icon-plus"></i> 添加
            </el-button>
          </div>
          <el-table
            :data="groupBuySettingManageInfo.groupBuySettings"
            border
            style="width: 100%"
          >
            <el-table-column prop="settingId" label="设置ID" align="center" />
            <el-table-column prop="groupBuyName" label="拼团名称" align="center" />
            <el-table-column prop="groupBuyDesc" label="拼团简介" align="center" />
            <el-table-column prop="validHours" label="拼团时效" align="center" />
            <el-table-column prop="startTime" label="开始时间" align="center" />
            <el-table-column prop="endTime" label="结束时间" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="_openEditGroupBuySettingModel(scope.row)"
                >修改</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 20px;"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-group-buy-setting ref="addGroupBuySetting" @refresh="_listGroupBuySettings" />
    <edit-group-buy-setting ref="editGroupBuySetting" @refresh="_listGroupBuySettings" />
    <delete-group-buy-setting ref="deleteGroupBuySetting" @refresh="_listGroupBuySettings" />
  </div>
</template>

<script>
import { queryGroupBuySetting } from '@/api/goods/groupBuySettingApi'
import AddGroupBuySetting from '@/components/goods/addGroupBuySetting/AddGroupBuySetting'
import EditGroupBuySetting from '@/components/goods/editGroupBuySetting/EditGroupBuySetting'
import DeleteGroupBuySetting from '@/components/goods/deleteGroupBuySetting/DeleteGroupBuySetting'
//import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'GroupBuySettingManage',
  components: {
    AddGroupBuySetting,
    EditGroupBuySetting,
    DeleteGroupBuySetting
  },
  data() {
    return {
      groupBuySettingManageInfo: {
        groupBuySettings: [],
        conditions: {
          groupBuyName: '',
          validHours: '',
          settingId: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this._listGroupBuySettings(1, 10)
  },
  methods: {
    async _listGroupBuySettings(page, rows) {
      this.groupBuySettingManageInfo.conditions.page = page
      this.groupBuySettingManageInfo.conditions.row = rows
      try {
        const res = await queryGroupBuySetting(this.groupBuySettingManageInfo.conditions)
        this.groupBuySettingManageInfo.groupBuySettings = res.data
        this.total = res.records
      } catch (error) {
        console.error('获取拼团设置列表失败:', error)
      }
    },
    _openAddGroupBuySettingModal() {
      this.$refs.addGroupBuySetting.open()
    },
    _openEditGroupBuySettingModel(row) {
      this.$refs.editGroupBuySetting.open(row)
    },
    _openDeleteGroupBuySettingModel(row) {
      this.$refs.deleteGroupBuySetting.open(row)
    },
    _queryGroupBuySettingMethod() {
      this._listGroupBuySettings(1, 10)
    },
    _resetGroupBuySettingMethod() {
      this.groupBuySettingManageInfo.conditions = {
        groupBuyName: '',
        validHours: '',
        settingId: '',
        page: 1,
        row: 10
      }
      this._listGroupBuySettings(1, 10)
    },
    handleCurrentChange(val) {
      this._listGroupBuySettings(val, 10)
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-col {
  width: 100%;
}
</style>